var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/modules/_has.js
// module id = 52
// module chunks = 0